import React from 'react'
import { connect } from 'react-redux'
import TemplatesBase from './TemplatesBase'

import { set_path } from '../actions/'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedTemplateResults extends React.Component {
  componentWillMount() {
    this.props.setPath('templateresults') // change depending on component
  }

  render() {
    return <TemplatesBase header="Template Results" templatebase="results" />
  }
}

const TemplateResults = connect(mapStateToProps, mapDispatchToProps)(ConnectedTemplateResults)

export default TemplateResults



// WEBPACK FOOTER //
// ./src/js/components/TemplateResults.js